var reflDirAnisoPS = `
void getReflDir() {
		float roughness = sqrt(1.0 - min(dGlossiness, 1.0));
		float anisotropy = material_anisotropy * roughness;
		vec3 anisotropicDirection = anisotropy >= 0.0 ? dTBN[1] : dTBN[0];
		vec3 anisotropicTangent = cross(anisotropicDirection, dViewDirW);
		vec3 anisotropicNormal = cross(anisotropicTangent, anisotropicDirection);
		vec3 bentNormal = normalize(mix(normalize(dNormalW), normalize(anisotropicNormal), anisotropy));
		dReflDirW = reflect(-dViewDirW, bentNormal);
}
`;

export { reflDirAnisoPS as default };
